import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

type TermHelpProps = {
  term: string;
  explanation: string;
};

/** Small, reusable plain-English explanation for technical product terms. */
export default function TermHelp({ term, explanation }: TermHelpProps) {
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" component="span">
      <Typography component="span" variant="inherit">{term}</Typography>
      <Tooltip title={explanation} arrow>
        <HelpOutline sx={{ fontSize: 15, color: 'text.secondary', cursor: 'help' }} />
      </Tooltip>
    </Stack>
  );
}
